import React from 'react';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';

/**
 * Renders MUI Icon button to remove device setting.
 * @returns {React.FC}
 */

const DeviceItemActions = ({ deleteDeviceItem }) => (
  <IconButton size="small" onClick={deleteDeviceItem}>
    <Tooltip title="Delete appliance device group">
      <DeleteIcon />
    </Tooltip>
  </IconButton>
);

export default DeviceItemActions;
